"use client"

import { useEffect } from "react"
import Clarity from "@microsoft/clarity"

export default function ClarityTracking() {
    useEffect(() => {
        Clarity.init("xwjae6l1y9")
    }, [])

    return null
}
